import { cx } from '../lib/cx.ts';

type StatTileProps = {
  label: string;
  value: string | number;
  /** Context for the number. Never a target or a judgement — see PRD.md. */
  hint?: string;
  className?: string;
};

export function StatTile({ label, value, hint, className }: StatTileProps) {
  return (
    <div className={cx('rounded-lg bg-surface px-4 py-3 shadow-sm', className)}>
      {/*
        The one place the serif touches data. A headline total is a headline,
        and Newsreader is what makes it read as one — everything smaller stays
        in Inter so its columns of numbers stay aligned. `tabular-nums` is kept
        explicitly here rather than left to the root, because this is the number
        most likely to be re-rendered beside another one.
      */}
      <div className="font-serif text-3xl font-strong tracking-tight tabular-nums text-text">
        {value}
      </div>
      <div className="text-sm text-muted">{label}</div>
      {hint === undefined ? null : <div className="pt-0.5 text-xs text-faint">{hint}</div>}
    </div>
  );
}
